/*!
 * devextreme-angular
 * Version: 16.2.5
 * Build date: Tue Feb 28 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var nested_option_1 = require('../../core/nested-option');
var nested_option_2 = require('../../core/nested-option');
var DxiTotalItemComponent = (function (_super) {
    __extends(DxiTotalItemComponent, _super);
    function DxiTotalItemComponent(parentOptionHost, optionHost) {
        _super.call(this);
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    Object.defineProperty(DxiTotalItemComponent.prototype, "alignment", {
        get: function () {
            return this._getOption('alignment');
        },
        set: function (value) {
            this._setOption('alignment', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiTotalItemComponent.prototype, "column", {
        get: function () {
            return this._getOption('column');
        },
        set: function (value) {
            this._setOption('column', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiTotalItemComponent.prototype, "cssClass", {
        get: function () {
            return this._getOption('cssClass');
        },
        set: function (value) {
            this._setOption('cssClass', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiTotalItemComponent.prototype, "customizeText", {
        get: function () {
            return this._getOption('customizeText');
        },
        set: function (value) {
            this._setOption('customizeText', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiTotalItemComponent.prototype, "displayFormat", {
        get: function () {
            return this._getOption('displayFormat');
        },
        set: function (value) {
            this._setOption('displayFormat', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiTotalItemComponent.prototype, "name", {
        get: function () {
            return this._getOption('name');
        },
        set: function (value) {
            this._setOption('name', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiTotalItemComponent.prototype, "precision", {
        get: function () {
            return this._getOption('precision');
        },
        set: function (value) {
            this._setOption('precision', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiTotalItemComponent.prototype, "showInColumn", {
        get: function () {
            return this._getOption('showInColumn');
        },
        set: function (value) {
            this._setOption('showInColumn', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiTotalItemComponent.prototype, "skipEmptyValues", {
        get: function () {
            return this._getOption('skipEmptyValues');
        },
        set: function (value) {
            this._setOption('skipEmptyValues', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiTotalItemComponent.prototype, "summaryType", {
        get: function () {
            return this._getOption('summaryType');
        },
        set: function (value) {
            this._setOption('summaryType', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiTotalItemComponent.prototype, "valueFormat", {
        get: function () {
            return this._getOption('valueFormat');
        },
        set: function (value) {
            this._setOption('valueFormat', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiTotalItemComponent.prototype, "_optionPath", {
        get: function () {
            return 'totalItems';
        },
        enumerable: true,
        configurable: true
    });
    DxiTotalItemComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'dxi-total-item',
                    template: '',
                    styles: [''],
                    providers: [nested_option_1.NestedOptionHost]
                },] },
    ];
    DxiTotalItemComponent.ctorParameters = function () { return [
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.SkipSelf }, { type: core_1.Host },] },
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.Host },] },
    ]; };
    DxiTotalItemComponent.propDecorators = {
        'alignment': [{ type: core_1.Input },],
        'column': [{ type: core_1.Input },],
        'cssClass': [{ type: core_1.Input },],
        'customizeText': [{ type: core_1.Input },],
        'displayFormat': [{ type: core_1.Input },],
        'name': [{ type: core_1.Input },],
        'precision': [{ type: core_1.Input },],
        'showInColumn': [{ type: core_1.Input },],
        'skipEmptyValues': [{ type: core_1.Input },],
        'summaryType': [{ type: core_1.Input },],
        'valueFormat': [{ type: core_1.Input },],
    };
    return DxiTotalItemComponent;
}(nested_option_2.CollectionNestedOption));
exports.DxiTotalItemComponent = DxiTotalItemComponent;
var DxiTotalItemModule = (function () {
    function DxiTotalItemModule() {
    }
    DxiTotalItemModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [
                        DxiTotalItemComponent
                    ],
                    exports: [
                        DxiTotalItemComponent
                    ],
                },] },
    ];
    DxiTotalItemModule.ctorParameters = function () { return []; };
    return DxiTotalItemModule;
}());
exports.DxiTotalItemModule = DxiTotalItemModule;
//# sourceMappingURL=total-item-dxi.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme-angular/ui/nested/total-item-dxi.js
// module id = ../../../../devextreme-angular/ui/nested/total-item-dxi.js
// module chunks = 3